import { MILLI_IN_MIN } from '@cp/src/utils/DateHelper';
import { TicketStatus } from '../CsaTicketing/types';
import FieldSupport from './FieldSupport';
import TasksForMe from './TasksForMe';
import { SortBy, TabsKey } from './types';

export const CSA_COORDINATION_TABS = [
  {
    key: TabsKey.TASKS_FOR_ME,
    value: 'My tasks',
    component: <TasksForMe />,
    relativePath: '/tickets/tasks'
  },
  {
    key: TabsKey.FIELD_SUPPORT,
    value: 'Tasks for FE',
    component: <FieldSupport />,
    relativePath: '/tickets/field_support'
  }
];

export const sortByMap = {
  [SortBy.CREATED_AT]: 'CREATED_AT',
  [SortBy.STATUS]: 'STATUS'
};

export const TicketStatusOptions = [
  { label: 'Todo', value: TicketStatus.TODO },
  { label: 'In Progress', value: TicketStatus.IN_PROGRESS },
  { label: 'Done', value: TicketStatus.CLOSED }
];

export const getFilteredOptions = (status: string) => {
  if (status === TicketStatus.IN_PROGRESS) {
    return TicketStatusOptions.slice(1);
  }
  return TicketStatusOptions;
};

export const FIELD_SUPPORT_TABLE = 'FIELD_SUPPORT_TABLE';
export const TASKS_FOR_ME_TABLE = 'TASKS_FOR_ME_TABLE';
export const DEFAULT_PAGE_NUMBER = '1';
export const DEFAULT_PAGE_SIZE = '10';
export const CSA = 'CSA';
export const REQUESTED_SUPPORT_REQUESTS = 'requestedSupportRequests';
export const ASSIGNED_SUPPORT_REQUESTS = 'assignedSupportRequests';

export const SUCCESS_MESSAGES = {
  TICKET_CREATED: 'Task created successfully',
  COMMENT_ADDED: 'Comment added successfully',
  STATUS_UPDATED: 'Status updated successfully'
};

export const CSA_POLLING_TIME = 30 * MILLI_IN_MIN; // 30 mins;
export const UNACK = 'UNACK';
export const UNREAD = 'UNREAD';
